import { render, staticRenderFns } from "./last-activity-sidebar.vue?vue&type=template&id=d2611c38"
import script from "./last-activity-sidebar.vue?vue&type=script&lang=js"
export * from "./last-activity-sidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports